module.exports = __webpack_public_path__ + "img/Han_Doung.27cdb7b6.jpeg";